export default "__VITE_ASSET__B7ZmyBC6__"